import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c9ca930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-container bg-menu font-goldman" }
const _hoisted_2 = { class: "menu mx-auto" }
const _hoisted_3 = { class: "navbar bg-menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hamburger gg-menu" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "menu-items" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo text-xl md:text-2xl lg:text-3xl"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "hamburger-container",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item-container text-base text-xl xl:text-2xl", _ctx.menuOpen ? 'open' : ''])
      }, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu-item",
              key: key,
              onClick: ($event: any) => (_ctx.navigate(item))
            }, [
              _createVNode(_component_router_link, {
                class: "link",
                to: item.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 8, _hoisted_7))
          }), 128))
        ])
      ], 2)
    ])
  ]))
}